import React from 'react';
export const CFIconChevronSmallDown = {
    alias: 'chevron-small-down',
    defaultTitle: 'Chevron Small Down',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M12 15.5a.997.997 0 0 1-.707-.293l-4-4a.999.999 0 1 1 1.414-1.414l3.305 3.305 3.293-3.18a1 1 0 0 1 1.39 1.44l-4 3.861A.998.998 0 0 1 12 15.5Z' }))),
};
